module.exports = {"back-to-blog-list":"Back to blog list","related":"Related articles","see-all":"See all posts","subscribe":{"title":"Sign up for our email updates and stay updated"},"download-free-guide":"Download our FREE guide!","tags":"Tags"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/blog-post.json
// module id = f8o0
// module chunks = 0